export interface ProviderStyle {
  bg: string;
  text: string;
  label: string;
}

export const PROVIDER_STYLES: Record<string, ProviderStyle> = {
  garmin: { bg: 'rgba(59, 130, 246, 0.2)', text: '#60a5fa', label: 'Garmin' },
  fitbit: { bg: 'rgba(20, 184, 166, 0.2)', text: '#2dd4bf', label: 'Fitbit' },
  oura: { bg: 'rgba(139, 92, 246, 0.2)', text: '#a78bfa', label: 'Oura' },
  whoop: { bg: 'rgba(234, 179, 8, 0.2)', text: '#facc15', label: 'WHOOP' },
  strava: { bg: 'rgba(249, 115, 22, 0.2)', text: '#fb923c', label: 'Strava' },
  google: { bg: 'rgba(34, 197, 94, 0.2)', text: '#4ade80', label: 'Google' },
  'google-fit': { bg: 'rgba(34, 197, 94, 0.2)', text: '#4ade80', label: 'Google Fit' },
  google_health: { bg: 'rgba(132, 204, 22, 0.2)', text: '#a3e635', label: 'Google Health' },
  health_connect: { bg: 'rgba(99, 102, 241, 0.2)', text: '#818cf8', label: 'Health Connect' },
  sensorbio: { bg: 'rgba(236, 72, 153, 0.2)', text: '#f472b6', label: 'Sensor Bio' },
  withings: { bg: 'rgba(6, 182, 212, 0.2)', text: '#22d3ee', label: 'Withings' },
  polar: { bg: 'rgba(239, 68, 68, 0.2)', text: '#f87171', label: 'Polar' },
  suunto: { bg: 'rgba(234, 88, 12, 0.2)', text: '#fdba74', label: 'Suunto' },
  samsung: { bg: 'rgba(14, 165, 233, 0.2)', text: '#38bdf8', label: 'Samsung' },
  ultrahuman: { bg: 'rgba(168, 85, 247, 0.2)', text: '#c084fc', label: 'Ultrahuman' },
  apple: { bg: 'rgba(113, 113, 122, 0.2)', text: '#a1a1aa', label: 'Apple' },
  internal: { bg: 'rgba(34, 197, 94, 0.15)', text: '#22c55e', label: 'OW' },
};

export const DEFAULT_PROVIDER_STYLE: ProviderStyle = {
  bg: 'rgba(148, 163, 184, 0.2)',
  text: '#94a3b8',
  label: 'Unknown',
};

export function getProviderStyle(provider: string): ProviderStyle {
  const rawProvider = provider?.trim() || '';
  const normalizedProvider = rawProvider.toLowerCase();

  return PROVIDER_STYLES[normalizedProvider] ?? {
    ...DEFAULT_PROVIDER_STYLE,
    label: rawProvider || DEFAULT_PROVIDER_STYLE.label,
  };
}

export function getProviderLabel(provider: string): string {
  return getProviderStyle(provider).label;
}
